'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ctaButtons = require('./cta-buttons');

var _ctaButtons2 = _interopRequireDefault(_ctaButtons);

var _apiUserImages = require('./api-user-images');

var _apiUserImages2 = _interopRequireDefault(_apiUserImages);

var _embeddedTweets = require('./embedded-tweets');

var _embeddedTweets2 = _interopRequireDefault(_embeddedTweets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'SEO CTA Section',

    render: function render() {
        var props = this.props;
        return _jsx('div', {
            className: 'bg-plume'
        }, void 0, _react2['default'].createElement(_ctaButtons2['default'], props), _react2['default'].createElement(_apiUserImages2['default'], props), _react2['default'].createElement(_embeddedTweets2['default'], props));
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/common/cta-section.jsx
 ** module id = 814
 ** module chunks = 0
 **/